import { render, staticRenderFns } from "./CompGeneralTitleBar.vue?vue&type=template&id=73ed4a4c&scoped=true"
import script from "./CompGeneralTitleBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralTitleBar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ed4a4c",
  null
  
)

export default component.exports